<div
  class="absolute top-0 left-0 -mt-7 h-7 flex items-center justify-center p-1 gap-3 bg-blue-400 rounded-t text-white text-xs font-semibold"
>
  <h3 class="flex items-center justify-center">
    <flx-icon
      name="stars-flowx-yellow"
      class="mr-1"
    />
    <span class="whitespace-nowrap">{{ title() }}</span>
  </h3>

  <div class="flex items-center justify-center pointer-events-auto">
    @if (hasInfoButton()) {
      <button
        (click)="draftInfo()"
        class="w-6 h-5 flex items-center justify-center bg-blue-600 rounded mr-1"
      >
        <i class="ph ph-info text-[16px]"></i>
      </button>
    }

    @if (!isLastMsgError()) {
      <button
        (click)="keepDraft()"
        class="w-10 h-5 flex items-center justify-center bg-green-300 rounded-l"
      >
        <i class="ph ph-check text-[16px]"></i>
      </button>

      <button
        (click)="discardDraft()"
        class="w-10 h-5 flex items-center justify-center bg-red-300 rounded-r"
      >
        <i class="ph ph-trash-simple text-[16px]"></i>
      </button>
    }
  </div>
</div>
